module.exports = __webpack_public_path__ + "img/4-1.78afd838.jpg";